module.exports = __webpack_public_path__ + "img/662.528e3b1c.jpg";